import React, { useState } from 'react';
import EditModal from '../../components/form_elements/edit-modal';
import * as Yup from 'yup';
import EmployeeForm from './employee-form';
import { OptionalString, RequiredDate, RequiredString } from '../../components/form_elements/form-validators';
import useMsalApi from "../../components/use-msal-api";
import { useSelector, useDispatch } from 'react-redux';
import { updateEmployee } from '../../redux/actions/enrollments-actions';
import { mapProperties } from '../../components/property-mapper';

const EmployeeEdit = ({employee, show, setShow}) => {
    const [callApi] = useMsalApi();
    const enrollments = useSelector(s => s.enrollments);
    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        firstName: RequiredString("Required"),
        lastName:  RequiredString("Required"),
        birthdate: RequiredDate("Required").max(new Date(), 'Invalid Date'),
        ssn:  RequiredString("Required").test("", "SSN must be 9 digits", (item) => item ? item.length === 11 : true)
            .test("", "Not a valid SSN", (item) =>  item ? /^(?!(000|666|9))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4})$/.test(item) : true)
            .test("", "Not a valid SSN", (item) =>  item ? item !== "123-45-6789" : true),
        maritalStatusId:  RequiredString("Required"),
        genderId:  RequiredString("Required"),
        addressLine1:  RequiredString("Required"),
        addressLine2:  OptionalString("Required"),
        city:  RequiredString("Required"),
        state:OptionalString().test("", "Required", (item, ctx) => { 
            console.log("Country", ctx.parent.country);
            return ctx.parent.country === "US" && (item === null || item === "") ? false : true
        }),
        region:OptionalString("Required").test("", "Required", (item, ctx) => { 
            return ctx.parent.country !== "US" && (item === null || item === "") ? false : true
        }),
        postalCode:  RequiredString("Required"),
        country:  RequiredString("Required"),
    });

    const onSubmit = async(formData) => {
        const frm = validationSchema.cast(formData);
        const params = {
            id: employee.id,
            firstName: frm.firstName,
            lastName: frm.lastName,
            birthdate: frm.birthdate,
            ssn: frm.ssn,
            maritalStatus: { id: frm.maritalStatusId, name: enrollments.maritalStatuses.find(s => s.id === frm.maritalStatusId).name},
            gender: {id :frm.genderId, name:enrollments.genders.find(s => s.id === frm.genderId).name},
            addressLine1: frm.addressLine1,
            addressLine2: frm.addressLine2,
            city: frm.city,
            state: frm.country === "US" ? frm.state : null,
            region:  frm.country === "US" ? null : frm.region,
            postalCode: frm.postalCode,
            country: frm.country
        }

        const results = await callApi(`Enrollments/${enrollments.id}/employee`, "PATCH", params);
        if(!results.error){
            let updatedEmployee = mapProperties(results, {...employee});
            dispatch(updateEmployee(updatedEmployee));
        }
    }


    return ( 
        <EditModal 
            title="Edit Employee"
            schema={validationSchema} 
            show={show} 
            setShow={setShow} 
            onSubmit={onSubmit}
            >
                <EmployeeForm employee={employee} show={show} />
            </EditModal>
     );
}
 
export default EmployeeEdit;